<template>
    <div class="input_group">
        <label :for="name">{{label}}</label>
        <input 
          :type="type"
          :value="value"
          :placeholder="placeholder"
          :name='name'
          @input="$emit('input', $event.target.value)" />
    </div>
</template>
<script>
export default {
  name: "input_group",
  props: {
    type: {
      type: String,
      default: "text"
    },
    value: String,
    placeholder: String,
    name: String,
    label: String
  }
};
</script>
<style scoped>
.input_group label {
    margin-right: 10px; 
}
</style>